<script setup lang="ts">
import type { PropType } from 'vue';
import { getApiRoot } from '~/utilities/api';

const props = defineProps({
  compact: Boolean as PropType<boolean>,
  offer: { type: Object as PropType<any>, required: true },
});
const { offer, compact } = toRefs(props);

const gobyStore = useGobyStore();

const submitInProgress = ref(false);

const getAndTakeOfferInGoby = async (offer: any) => {
  const offerBech32 = await $fetch<any>(`${getApiRoot()}/offers/${offer.id}/bech32`);

  if (offerBech32) {
    submitInProgress.value = true;
    try {
      await Promise.race([
        gobyStore.takeOffer(offerBech32),
        new Promise((_resolve, reject) =>
          setTimeout(() => reject(new Error('Offer taking timed out after 30 seconds')), 30000)
        ),
      ]);
    } catch (error) {
      console.error(error);
    } finally {
      submitInProgress.value = false;
    }
  }
};
</script>
<template>
  <button
    v-if="gobyStore.isWalletInstalled"
    type="button"
    :class="[
      compact ? 'bg-black px-6 py-2 text-sm dark:bg-neutral-100 dark:text-black ' : 'w-full bg-green-600 px-4 py-3',
    ]"
    class="betterhover:hover:shadow-card-hover flex items-center justify-center rounded-full border border-transparent font-semibold text-white transition duration-100 ease-in-out betterhover:hover:-translate-y-0.5"
    @click.prevent="getAndTakeOfferInGoby(offer)"
  >
    <svg
      v-if="submitInProgress"
      :class="[compact ? 'dark:image-black h-4 w-4' : 'h-6 w-6']"
      class="-ml-1 mr-2 h-5 w-5 animate-spin text-white dark:text-black"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
    <img
      v-else-if="gobyStore.type === 'goby'"
      :class="[compact ? 'dark:image-black -ml-1 mr-2 h-4 w-4' : '-ml-1 mr-2 h-6 w-6']"
      aria-hidden="true"
      src="/goby-logo-white.svg"
    />
    <img
      v-else-if="gobyStore.type === 'walletconnect'"
      :class="[compact ? 'dark:image-black -ml-1 mr-2 h-4 w-4' : '-ml-1 mr-2 h-6 w-6']"
      src="https://sagewallet.net/assets/sage-logo.png"
    />
    <slot></slot>
  </button>
  <NuxtLink
    v-else
    :to="`/offers/${offer.id}`"
    :class="[compact ? 'bg-black px-6 py-2 text-sm' : 'w-full bg-green-600 px-4 py-3']"
    class="betterhover:hover:shadow-card-hover flex items-center justify-center rounded-full border border-transparent font-semibold text-white transition duration-100 ease-in-out dark:bg-neutral-100 dark:text-black betterhover:hover:-translate-y-0.5"
  >
    <slot></slot>
  </NuxtLink>
</template>
